// Globals
import React, { useCallback } from 'react';
import { Switch } from 'antd';
import { useTranslation } from 'react-i18next';

// Components
import { PopConfirm } from '@/ui';
import { useUpdateShowBrand } from '../../hooks';

type TShowBrandSwitch = {
  brandId: string;
  showOnBrandPage: boolean;
};

const ShowBrandSwitch = ({ brandId, showOnBrandPage }: TShowBrandSwitch) => {
  const { t } = useTranslation(['common']);
  const { updateBrandDisplay, isLoading } = useUpdateShowBrand();

  const handleChange = useCallback(
    () => updateBrandDisplay(brandId, showOnBrandPage ? false : true),
    [brandId, showOnBrandPage, updateBrandDisplay],
  );

  return (
    <div onClick={(e) => e.stopPropagation()} onKeyDown={(e) => e.stopPropagation()}>
      <PopConfirm
        title={t(showOnBrandPage ? 'modal_brand_display_hide_title' : 'modal_brand_display_title')}
        onConfirm={handleChange}
      >
        <Switch
          checked={showOnBrandPage}
          checkedChildren={t('modal_brand_shown_title')}
          unCheckedChildren={t('modal_brand_hidden_title')}
          loading={isLoading}
        />
      </PopConfirm>
    </div>
  );
};

export default ShowBrandSwitch;
